module.exports = __webpack_public_path__ + "static/media/6-active.f1b921c1.png";